const formatarTexto = (texto, format) => {
  if (format) {
    
    let textoComQuebrasDeLinha = texto.replace(/\n/g, '<br>');
    return textoComQuebrasDeLinha;
  } else {
    
    let textoSemLinks = texto.replace(/<a[^>]*>(.*?)<\/a>/g, '$1');
    let textoComQuebrasDeLinha = textoSemLinks.replace(/\n/g, '<br>');
    return textoComQuebrasDeLinha;
  }
};

export function TextoFormatado({ itemContent, format }) {
  return (
    <div>
      <p dangerouslySetInnerHTML={{ __html: formatarTexto(itemContent, format) }} />
    </div>
  );
};